import { VFC } from 'react';

import { ScoreBoardTemplateProps } from '../ScoreBoardTemplateManager/types';

/** Displays the compact scoreboard with only a name template */
export const ScoreBoardCompactOneNameOnlyTemplate: VFC<
  ScoreBoardTemplateProps
> = () => null;
